/** Mirror backend registry feature codenames */
export const AUTHZ_FEATURES = Object.freeze({
  INTERVENE: Object.freeze({
    DASHBOARD: 'can_view_intervene_new',
    CALLING: 'can_use_intervene_calling',
    CHAT: 'can_view_intervene_chat',
  }),
  WHATSAPP: Object.freeze({
    SEND_TEMPLATE: 'can_send_whatsapp_template',
    OPTIN_USERS: 'can_view_optin_users',
    WABA_APP_LIST: 'can_view_waba_app_list',
    TEMPLATE_PERFORMANCE: 'can_view_template_performance',
  }),
  SMS: Object.freeze({
    SEND_TEMPLATE: 'can_send_sms_template',
    SEND_BULK: 'can_send_sms_bulk_template',
    VIEW_LOGS: 'can_view_sms_logs',
    DOWNLOAD_LOGS: 'can_download_sms_logs',
  }),
  FLOW: Object.freeze({
    PUBLISH: 'can_publish_flow',
  }),
  REPORTING: Object.freeze({
    VIEW: 'can_view_report_sidebar',
  }),
  ANALYTICS: Object.freeze({
    VIEW: 'can_view_analytics',
    CREATE: 'can_create_custom_reports',
    DELETE: 'can_delete_custom_reports',
    EXPORT: 'can_export_analytics',
    RECORDS: 'can_view_analytics_records',
    WHATSAPP: 'can_view_analytics_whatsapp',
    INTERVENE: 'can_view_analytics_intervene',
  }),
  EDTECH: Object.freeze({
    CONCEPT_BUILDER: 'can_view_concept_builder',
    PRACTICE_TEST: 'can_view_test_creator',
    KNOWLEDGE_MAP: 'can_view_knowledge_map',
    PERFORMANCE_MAP: 'can_view_learning_intelligence',
    PARENT_DASHBOARD: 'can_view_parent_dashboard',
    TEACHER_DASHBOARD: 'can_view_teacher_dashboard',
    ACADEMIC_INFO: 'can_view_academic_info',
    QUESTION_BANK: 'can_view_question_bank',
    SYLLABUS_BUILDER: 'can_view_syllabus_builder',
    AI: 'can_view_ai_dashboard',
    VECTOR_DATABASE: 'can_view_vector_database',
    TOOLS: 'can_view_url_generator_page',
  }),
  USER: Object.freeze({
    UNLOCK: 'can_unlock_user',
  }),
  RECORDS: Object.freeze({
    VIEW: 'can_view_records',
    CREATE: 'can_create_records',
    UPDATE: 'can_update_records',
    DELETE: 'can_delete_records',
    ASSIGN: 'can_assign_record',
    VIEW_STATUS_LOGS: 'can_view_record_status_logs',
    SEND_TEMPLATE: 'can_send_record_template',
    VIEW_IMAGES: 'can_view_record_images',
    QUICK_CALL: 'can_quick_call_record',
    CHAT: 'can_chat_record',
    MANAGE_ADMIN: 'can_manage_record_admin',
    ADD_COMMENT: 'can_add_record_comment',
    DOWNLOAD: 'can_download_records',
    IMPORT: 'can_import_records',
    MOVE: 'can_move_leads',
  }),
  LEAD_OPERATIONS: Object.freeze({
    DOWNLOAD: 'can_view_download_leads_column',
    IMPORT: 'can_view_import_leads_column',
  }),
});

/** @deprecated Use AUTHZ_FEATURES.RECORDS */
export const AUTHZ_RECORD_ACTIONS = AUTHZ_FEATURES.RECORDS;

export const AUTHZ_ACTIONS = Object.freeze({
  CAN_VIEW: 'can_view',
  CAN_CREATE: 'can_create',
  CAN_UPDATE: 'can_update',
  CAN_DELETE: 'can_delete',
  CAN_VIEW_ALL: 'can_view_all',
  CAN_UPDATE_ALL: 'can_update_all',
});

/** Lowercase model keys as returned by backend grants */
export const AUTHZ_OBJECTS = Object.freeze({
  PROFILE: 'profile',
  BASE_USER: 'baseuser',
  ACCOUNT_INFO: 'accountinfo',
  PROPOSAL_INFO: 'proposalinfo',
  MESSAGE_TEMPLATE: 'messagetemplate',
  SMS_TEMPLATE: 'smstemplate',
  FLOW: 'flow',
  DATASET: 'dataset',
  DATASET_RECORD: 'datasetrecord',
});
